"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sequence = sequence;
exports.sequenceSafe = sequenceSafe;
exports.successes = successes;
// functions sorted alphabetically
// similar to `Promise.all` but sequential instead of parallel, "easy" rate limiting ^^
function sequence(arr, perform) {
    return arr.reduce((acc, t) => {
        return acc.then(res => perform(t).then(u => res.concat([u])));
    }, Promise.resolve([]));
}
// similar to `sequence` but do not fail and accumulate errors
function sequenceSafe(arr, perform) {
    return arr.reduce((acc, t) => {
        return acc.then(([errs, res]) => perform(t)
            .then(u => [errs, res.concat([u])])
            .catch(err => [errs.concat([[t, err]]), res]));
    }, Promise.resolve([[], []]));
}
// similar to `Promise.all` but collect only successful results and do not fail, run in parallel
function successes(arr) {
    return arr.reduce((acc, promise) => {
        return acc.then(res => promise.then(p => res.concat([p])).catch(_ => res));
    }, Promise.resolve([]));
}
//# sourceMappingURL=promise.js.map